export * from './format_phone_number.directive';

import { PhoneMask } from './format_phone_number.directive';

export const FORMATPHONENUMBER_DIRECTIVES: [any] = [PhoneMask];



// WEBPACK FOOTER //
// ./src/app/directives/format_phone_number/index.ts